module.exports = __webpack_public_path__ + "static/media/piggy-icon_2x.d018ac57.png";